// Info: Import React Dependancies
import React from "react";

// Info: Import NPM Dependancies
import { useSearchParams } from "react-router-dom";

// Info: Import Local Dependancies
import { useChatStream } from '../../services/useChatSteam';
import { getMessages } from '../../store/sitecoreSlice';
import { useDispatch, useSelector } from "react-redux";
import { setIsMessageLoaded } from "../../store/feedbackSlice";

import { getUid } from '../../services/commonUtil';
type ActionProviderProps = {
  createChatBotMessage: any;
  setState: any;
  children: any;
};
const ActionProvider: React.FC<ActionProviderProps> = ({ createChatBotMessage, setState, children }) => {
  const [searchParams] = useSearchParams();
  // const userId = useLocation().pathname.replace('/en/', '');
  const userId = searchParams?.get('uid');
  const uId = getUid();
  const dispatch = useDispatch()
  const { postMessage } = useChatStream(); // Use the postMessage function from useChatStream
  const chatMessages = useSelector(getMessages)
  const showHello = async (message: string) => {
    const payload = {
      message,
      userId: userId,
      uid: uId
    };
    // Add a dummy "streaming..." message for bot in the chat
    const botMessageId = Date.now(); // Create a temporary unique ID for the streaming message
    setState((prev: any) => ({
      ...prev,
      messages: [...prev.messages, createChatBotMessage("", "bot", botMessageId)], // Add dummy message

    }));
    try {
      // Handle streaming with intermediate updates
      const reply = await postMessage(payload, (partialMessage: string) => {
        // Update the last message with the partial message

        setState((prev: any) => {
          // const updatedMessages = prev.messages.map((msg: any) =>
          //   msg.id
          //     === botMessageId ? { ...msg, text: partialMessage } : msg
          // );
          // return { ...prev, messages: updatedMessages };
          let partialMsg = {
            "message": partialMessage,
            "type": "assistant",
            "id": botMessageId,
            "loading": false
          }
          return { ...prev, messages: [...prev.messages.slice(0, -1), partialMsg] };
        });
      });
      // Once streaming is done, finalize the message with the complete response

      let finalReply = reply;

      if (!finalReply) {

        finalReply = chatMessages?.botError;
      }
      let checkReply = reply.includes(chatMessages?.backendError);

      if (checkReply) {

        finalReply = chatMessages?.botError;
      }
      dispatch(setIsMessageLoaded(true))
      setState((prev: any) => {
        let replyMsg = {
          "message": finalReply,
          "type": "assistant",
          "id": botMessageId,
          "loading": false
        }
        return { ...prev, messages: [...prev.messages.slice(0, -1), replyMsg] };
      });
    } catch (error) {

      // Handle error by replacing the message with an error notice
      setState((prev: any) => {
        let replyMsg = {
          "message": chatMessages?.botError,
          "type": "assistant",
          "id": botMessageId,
          "loading": false
        }
        return { ...prev, messages: [...prev.messages.slice(0, -1), replyMsg] };
      });
    }
  };
  // Return children with actions passed as props
  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: { showHello }, // Pass down the showHello action to children
        });
      })}
    </>
  );
};
export default ActionProvider;